import type { Stop, StopJob, StopsQueue } from '../stops-queue/stops-queue.interface';
import { STOPS_QUEUE_STATUS } from '../stops-queue/stops-queue.interface';
import { TASK_JOB_TYPE } from '../task/task.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class StopJobFactory extends ObjectFactory<StopJob> {
  protected getDefaults(): StopJob {
    return {
      id: 'aabbccddeeff001122334455',
      orderId: 'bbccddeeff001122334455aa',
      sortIndex: 0,
      taskId: 'ccddeeff001122334455aabb',
      type: TASK_JOB_TYPE.DELIVERY,
    };
  }
}

export const stopJobFactory = new StopJobFactory();

export class StopFactory extends ObjectFactory<Stop> {
  protected getDefaults(): Stop {
    return {
      arrivedAt: undefined,
      completedJobAt: undefined,
      eta: undefined,
      failedJobAt: undefined,
      fullAddress: '1 Rue de Paris',
      id: 'ddeeff001122334455aabbcc',
      initialEta: undefined,
      jobs: [stopJobFactory.build()],
      routePolyline: undefined,
      timeSlot: undefined,
      userComment: undefined,
    };
  }
}

export const stopFactory = new StopFactory();

export class StopsQueueFactory extends ObjectFactory<StopsQueue> {
  protected getDefaults(): StopsQueue {
    return {
      ...baseDocumentFactory.build(),
      carrierId: 'ccddee112233445566778899',
      driverId: 'aabb1122334455667788aabb',
      status: STOPS_QUEUE_STATUS.ONGOING,
      stops: [],
    };
  }
}

export const stopsQueueFactory = new StopsQueueFactory();
